import React from "react";
import {
  Link,
  useLocation,
} from "react-router-dom";

import "../../styles/navbar.css";

const WebsiteNavbar = () => {

  const location = useLocation();


  const isActive = (path) => {

    return location.pathname === path;

  };


  return (
    <header className="website-navbar">

      <div className="navbar-container">

        {/* Logo */}

        <Link
          to="/"
          className="navbar-logo"
        >

          <span className="logo-mark">
            H
          </span>

          <span className="logo-text">
            Harsha <strong>IT</strong>
          </span>

        </Link>


        {/* Navigation */}

        <nav className="navbar-links">

          <Link
            to="/"
            className={
              isActive("/")
                ? "active"
                : ""
            }
          >
            Home
          </Link>


          <Link
            to="/products"
            className={
              isActive("/products")
                ? "active"
                : ""
            }
          >
            Products
          </Link>


          <Link
            to="/about"
            className={
              isActive("/about")
                ? "active"
                : ""
            }
          >
            About
          </Link>


          <Link
            to="/contact"
            className={
              isActive("/contact")
                ? "active"
                : ""
            }
          >
            Contact
          </Link>

        </nav>


        {/* CTA */}

        <Link
          to="/contact"
          className="navbar-cta"
        >
          Let's Talk
        </Link>

      </div>

    </header>
  );
};

export default WebsiteNavbar;